var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ loading: _vm.loading }},[_vm._t("default",function(){return [_vm._v("Go")]}),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"spinner"},[_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }